// TO-DO : Remove unused values ( commented out export consts )

import { AsymmetryScalingVariableEnum } from '@shared/enums/asymmetry-enums';
import { HorseBodyPartEnum } from '@sleipai/sleip-models';

export const defaultEmptyLevels = [0, 0, 0, 0, 0];

// New Redesigned Clockplot Color Levels Start

export const ASYMMETRY_VECTOR_PLOT_COLOR_LEVELS = {
  [AsymmetryScalingVariableEnum.HORSE_RELATIVE_SCALED]: {
    [HorseBodyPartEnum.HEAD]: [0.05, 0.0375, 0.025, 0.0125],
    [HorseBodyPartEnum.HIND]: [0.02857143, 0.02142857, 0.01428571, 0.00714286],
    [HorseBodyPartEnum.WITHERS]: [
      0.02857144, 0.02142857, 0.01428571, 0.00714286,
    ],
  },
  [AsymmetryScalingVariableEnum.MEAN_EXTREMES_DIFF_SCALED]: {
    [HorseBodyPartEnum.HEAD]: [0.8, 0.6, 0.4, 0.2],
    [HorseBodyPartEnum.HIND]: [0.5, 0.375, 0.25, 0.125],
    [HorseBodyPartEnum.WITHERS]: [0.5, 0.375, 0.25, 0.125],
  },
};
// New Redesigned Clockplot Color Levels End
